import { connect } from 'react-redux';
import { areaStyle } from './dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';


import { getProjectId } from '../selectors/project.selector';
import { ThunkDispatch } from 'redux-thunk';
import { firebaseConnect } from 'react-redux-firebase';
import { withRouter } from "react-router";
import AreaScreen from '../components/AreaScreen';
import { 
    getSelectedLookaheadId, 
    lookaheadTagFBConnect,
    getLookaheadNames, getLookaheadName, getAreas
} from '../selectors/lookahead.selector';

const mapStateToProps = (state: any) => ({


});

const mapDispatchToProps = () => {

    return {

    }
};


export default compose<React.ComponentClass>(
    connect(state => {
        return {
            projectId: getProjectId(state),
            lookaheadId: getSelectedLookaheadId(state)
        };
    }),
    firebaseConnect(lookaheadTagFBConnect),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(areaStyle, { withTheme: true }),

)(AreaScreen)



// WEBPACK FOOTER //
// ./src/containers/AreaContainer.ts